import { OPERATION_IDS, MODULE_KEYS, ICON_IDS, I18N_KEYS, } from '../experience/routes/ids.js';
export const SHELL_NAVIGATION_SLOTS = [
    {
        id: 'shell.nav.home',
        placement: 'primary',
        routeId: 'dashboard',
        iconKey: 'dashboard',
        labelKey: 'nav.dashboard',
        descriptionKey: 'dashboard.tagline',
        order: 10,
        module: 'DASHBOARD',
        operationId: OPERATION_IDS.DASHBOARD_VIEW,
    },
    {
        id: 'shell.nav.data',
        placement: 'primary',
        routeId: 'data-hub',
        iconKey: 'accountBalance',
        labelKey: 'nav.data',
        descriptionKey: 'dataHub.description',
        order: 20,
        module: 'DATA',
        operationId: OPERATION_IDS.DATA_HUB,
    },
    {
        id: 'shell.nav.reports',
        placement: 'primary',
        routeId: 'reports',
        iconKey: 'reports',
        labelKey: 'nav.reports',
        descriptionKey: 'reports.description',
        order: 30,
        module: 'REPORTING',
        operationId: OPERATION_IDS.REPORTS_VIEW,
    },
    {
        id: 'shell.nav.admin',
        placement: 'primary',
        routeId: 'admin-hub',
        iconKey: 'security',
        labelKey: 'nav.admin',
        descriptionKey: 'admin.overview.title',
        order: 40,
        module: 'ADMIN',
        operationId: OPERATION_IDS.ADMIN_HUB,
    },
    {
        id: 'shell.nav.transactions',
        placement: 'primary',
        routeId: 'transactions',
        iconKey: ICON_IDS.TRANSACTIONS,
        labelKey: I18N_KEYS.NAVIGATION_TRANSACTIONS,
        order: 31,
        module: MODULE_KEYS.TRANSACTIONS,
        operationId: OPERATION_IDS.TRANSACTION_LIST,
    },
    {
        id: 'shell.nav.holdings',
        placement: 'primary',
        routeId: 'holdings',
        iconKey: ICON_IDS.HOLDINGS,
        labelKey: I18N_KEYS.NAVIGATION_HOLDINGS,
        order: 32,
        module: MODULE_KEYS.HOLDINGS,
        operationId: OPERATION_IDS.HOLDINGS_VIEW,
    },
    {
        id: 'shell.nav.reconciliation',
        placement: 'primary',
        routeId: 'reconciliation',
        iconKey: ICON_IDS.RECONCILIATION,
        labelKey: I18N_KEYS.NAVIGATION_RECONCILIATION,
        order: 33,
        module: MODULE_KEYS.RECONCILIATION,
        operationId: OPERATION_IDS.RECONCILIATION_VIEW,
    },
    {
        id: 'shell.nav.corporateActions',
        placement: 'primary',
        routeId: 'corporate-actions',
        iconKey: ICON_IDS.CORPORATE_ACTIONS,
        labelKey: I18N_KEYS.NAVIGATION_CORPORATE_ACTIONS,
        order: 34,
        module: MODULE_KEYS.CORPORATE_ACTIONS,
        operationId: OPERATION_IDS.CORPORATE_ACTIONS_VIEW,
    },
    // Note: The settings hub is not included as a secondary slot. The avatar
    // menu receives destination-level navigation (profile, preferences, MFA,
    // password, sessions) directly from the AvatarNavigationResolverService,
    // making a redundant "Settings" hub entry unnecessary.
];
